<div class="main-content">
  <div class="main-container">
    <ov-suite-hierarchy-table
      #journalTable
      [title]="'Journal Events'"
      [formClass]="formClass"
      [hasBulkUpload]="false"
      [hasBulkExport]="false"
      [excludeColumns]="4"
      [hideAddButton]="false"
      [overrideAddButtonClick]="true"
      [defaultOrderDirection]="'DESC'"
      [orderColumn]="'date'"
      (addButtonClick)="onAdd()"
    >
    </ov-suite-hierarchy-table>
  </div>
</div>
